/**
 * @generated SignedSource<<3440e8eb00fd8b81480388f2c38bdc23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoToolbarButtonTeamsDetail_teams$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
  readonly " $fragmentType": "TodoToolbarButtonTeamsDetail_teams";
}>;
export type TodoToolbarButtonTeamsDetail_teams$key = ReadonlyArray<{
  readonly " $data"?: TodoToolbarButtonTeamsDetail_teams$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTeamsDetail_teams">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoToolbarButtonTeamsDetail_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIconCircle"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "daa3b6c5e76c11bcc2daff43e6b8dec1";

export default node;
